import { SELLERS_ACTIONS_TYPES } from "./sellers.types";

export const INITIAL_STATE = {
	sellers: [],
	typeDocs: [],
};

export const sellersReducer = (state = INITIAL_STATE, action = {}) => {
	// process.env.NODE_ENV !== "production" && console.log("dispatch");
	// process.env.NODE_ENV !== "production" && console.log(action);
	const { type, payload } = action;
	switch (type) {
		// case USER_ACTIONS_TYPES.SET_CURRENT_USER:
		// 	const isAdminUser = setIsAdminUserReducer(payload);
		// 	return {
		// 		...state,
		// 		currentUser: payload,
		// 		isAdmin: isAdminUser
		// 	};
		case SELLERS_ACTIONS_TYPES.SET_SELLERS:
			return {
				...state,
				sellers: payload
			};
		case SELLERS_ACTIONS_TYPES.SET_TYPEDOCS:
			return {
				...state,
				typeDocs: payload
			};
		default:
			return state;
	}
};
